namespace TabAurous.Sales {
    export interface RateFixingForm {
        TransDate: Serenity.DateEditor;
        Posted: LabelEditor;
        TransId: Serenity.StringEditor;
        VoucherNo: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        AutoPosting: Serenity.BooleanEditor;
        PartyId: Serenity.LookupEditor;
        LedgerName: Serenity.StringEditor;
        GstVat: Serenity.StringEditor;
        Address1: Serenity.TextAreaEditor;
        Country: Serenity.StringEditor;
        State: Serenity.StringEditor;
        Weight: Serenity.DecimalEditor;
        Rate: Serenity.DecimalEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchRate: Serenity.DecimalEditor;
        EmployeeId: Serenity.IntegerEditor;
        ItemDetails: RateFixingItemsEditor;
        TaxDetails: RateFixingTaxEditor;
        Remark: Serenity.TextAreaEditor;
        NetAmount: Serenity.DecimalEditor;
        TaxAmount: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        AdditionalCharges: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        RoundOff: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
        BillNo: Serenity.StringEditor;
        BillDate: Serenity.DateEditor;
        ChallanNo: Serenity.StringEditor;
        ChallanDate: Serenity.DateEditor;
        BillAddId: Serenity.IntegerEditor;
        ShipmentId: Serenity.IntegerEditor;
        ShipAddressId: Serenity.IntegerEditor;
        UserId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
    }

    export class RateFixingForm extends Serenity.PrefixedContext {
        static formKey = 'Sales.RateFixing';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!RateFixingForm.init)  {
                RateFixingForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = LabelEditor;
                var w2 = s.StringEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.BooleanEditor;
                var w5 = s.LookupEditor;
                var w6 = s.TextAreaEditor;
                var w7 = s.DecimalEditor;
                var w8 = RateFixingItemsEditor;
                var w9 = RateFixingTaxEditor;

                Q.initFormType(RateFixingForm, [
                    'TransDate', w0,
                    'Posted', w1,
                    'TransId', w2,
                    'VoucherNo', w2,
                    'VoucherTypeId', w3,
                    'AutoPosting', w4,
                    'PartyId', w5,
                    'LedgerName', w2,
                    'GstVat', w2,
                    'Address1', w6,
                    'Country', w2,
                    'State', w2,
                    'Weight', w7,
                    'Rate', w7,
                    'CurrencyId', w5,
                    'ExchRate', w7,
                    'EmployeeId', w3,
                    'ItemDetails', w8,
                    'TaxDetails', w9,
                    'Remark', w6,
                    'NetAmount', w7,
                    'TaxAmount', w7,
                    'Discount', w7,
                    'AdditionalCharges', w7,
                    'GrossAmount', w7,
                    'RoundOff', w3,
                    'CompanyId', w3,
                    'BillNo', w2,
                    'BillDate', w0,
                    'ChallanNo', w2,
                    'ChallanDate', w0,
                    'BillAddId', w3,
                    'ShipmentId', w3,
                    'ShipAddressId', w3,
                    'UserId', w3,
                    'FinancialYearId', w3
                ]);
            }
        }
    }
}
